import {Link} from "react-router-dom";

//CSS
import styles from "./featuredExcursions.module.less";

export default function FeaturedExcursions ({excursions, language, zone}) {

  let excursionsHTML = "No hay excursiones populares";

  if(Array.isArray(excursions) && excursions.length > 0){
    excursionsHTML = excursions.map((excursion,index)=>{

      return (
        <div className={styles.excursion} key={index}>
          <Link to={'/' + language + '/excursion/' + zone + '/' + excursion.webslug}>
            {excursion.webthumbnail && <img className={styles.webthumbnail} src={excursion.webthumbnail}/>}
            {excursion.mobilethumbnail && <img className={styles.mobilethumbnail} src={excursion.mobilethumbnail}/>}
            <div className={styles.sheet}>
              <div className={styles.background}>&nbsp;</div>
              <div className={styles.contentexcursion}>
                <div className={styles.name}>{excursion.webtitle}</div>
                <div className={styles.price}>desde: <span> {excursion.prices[excursion.pricehighlight.id].price.toFixed(2)}  &euro;</span></div>
              </div>
            </div>
          </Link>
        </div>
      );
    });
  }

  return (
    <div className={styles.featuredExcursions}>
      {excursionsHTML}
    </div>
  );

}
